import React, {Component} from 'react';
import axios from 'axios';
// import NumberFormat from 'react-number-format';
import { Cookies } from 'react-cookie';
// import { Tooltip } from 'react-tippy';
import 'react-tippy/dist/tippy.css';

class SendQuote extends Component {
  constructor (props) {
    super(props);
    this.state = {
      url: `${process.env.REACT_APP_API_URL}/services/plan`,
      area: props.area,
      first_name: '',
      last_name: '',
      phone: '',
      company: '',
      email: '',
      county: this.props.Location,
      marketingSource: '',
      formErrors: {},
      success: false,
      submitting: false
    };
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  componentDidMount () {
    const cookies = new Cookies();
    const MarketingCampaignSource = (cookies.get('CDPHP_Marketing_Campaign_Source')) ? cookies.get('CDPHP_Marketing_Campaign_Source') : 'Not Set';
    this.setState({
      marketingSource: MarketingCampaignSource
    });
  }

  handleInputChange = (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  handleSubmit = (event) => {
    event.preventDefault();

    let formResults;
    let lead;

    if (this.state.area === 'MedicareSaveQuote' || this.state.area === 'MedicareSaveQuoteWesternNY') {
      formResults = {
        'area': this.state.area,
        'first_name': this.state.first_name,
        'last_name': this.state.last_name,
        'email': this.state.email,
        'phone': this.state.phone,
        'sendQuote': true,
        'sendQuoteURL': window.location.href,
        'County__c': this.state.county ? this.state.county.loc.County : this.props.county.County,
        'Preferred_Construct__c': (this.props.details && this.props.details.CostPreference === 1) ? 'Lower Premium' : 'Lower OOP',
        'details': this.props.details,
        'last_shown_plan_id': this.props.lastPlanId,
        'Campaign__c': this.state.marketingSource.leadCampaign,
        'Content__c': this.state.marketingSource.leadContent,
        'Medium__c': this.state.marketingSource.leadMedium,
        'Source__c': this.state.marketingSource.leadSource,
        'GCLID__c': this.state.marketingSource.leadGCLID
      };
      lead = 'Medicare';
    }

    console.log(formResults);
    console.log(this.props.details);

    const errors = this.validateForm(formResults);
    const isDisabled = Object.keys(errors).some(x => errors[x]);
    if (!isDisabled) {
      this.setState({submitting: true});
      axios.post(
        this.state.url, formResults
      ).then(response => {
        console.log(response);
        this.setState({submitting: false});
        this.setState({success: true});
        this.resetForm();

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'event': 'formSubmit',
          'formID': 'Plans Microsite - ' + lead + ' Lead'
        });
      }).catch(error => {
        console.log('Error Message: ' + error);
      });
    } else {
      this.setState({formErrors: errors});
    }
  }

  validateForm = (formResults) => {
    let formErrors = {};

    if (formResults.first_name.length < 2) {
      formErrors.first_name = 'Required';
    }

    if (formResults.last_name.length < 2) {
      formErrors.last_name = 'Required';
    }

    if (!formResults.email) {
      formErrors.email = 'Required';
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(formResults.email)) {
      formErrors.email = 'Invalid email address';
    }
    return formErrors;
  }

    closeForm = (event) => {
      this.resetForm();
      this.props.closeModal();
      var that = this;
      setTimeout(function () {
        that.setState({
          success: false
        });
      }, 500);
    }

    resetForm = () => {
      console.log('Reset');
      this.setState({
        formErrors: {},
        first_name: '',
        last_name: '',
        email: ''
      });
    }

    trackEnrollment = () => {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'GAEvent',
        'eventCategory': 'Click',
        'eventAction': 'Load Website',
        'eventLabel': 'Go to DRx',
        'eventValue': undefined
      });
    }

    render () {
      const display = (this.props.show === true ? 'show' : '');
      let Success = null;
      if (this.state.success) {
        Success = (<div id='success' className={this.state.success ? 'show' : ''}>
          <div>
            <h4>Check your email!</h4>
            <p>You&rsquo;ll find a link to get back to this page anytime.</p>
          </div>
        </div>);
      }

      return (
        <section id='sendQuoteOverlay' className={'modal ' + display}>
          <div id='overlayBG' onClick={(e) => this.closeForm(e)}>
            <div id='overlay' onClick={(event) => { event.stopPropagation(); }}>
              <div className='wrap sm text-center'>
                <div className={'guide' + (this.state.submitting ? ' loading' : '')}>
                  <button className='close' onClick={(e) => this.closeForm(e)}>Close</button>
                  <div className='inlineForm'>
                    <div className={this.state.submitting ? ' loading' : ''}>
                      <div className='form-content'>
                        <form onSubmit={this.handleSubmit}>
                          <p>
                            <label>My name is</label>
                            <span className='inputContainer'>
                              <input
                                name='first_name'
                                id='first_name'
                                type='text'
                                placeholder='First'
                                className={'first_name ' + (this.state.formErrors.first_name ? 'error' : '')}
                                value={this.state.first_name}
                                onChange={this.handleInputChange} />
                            </span>
                            <span className='inputContainer'>
                              <input
                                name='last_name'
                                id='last_name'
                                type='text'
                                placeholder='Last'
                                className={'last_name ' + (this.state.formErrors.last_name ? 'error' : '')}
                                value={this.state.last_name}
                                onChange={this.handleInputChange} />
                            </span>
                          </p>
                          <p>
                            <label>My email address is</label>
                            <input
                              name='email'
                              id='email'
                              type='text'
                              className={'email ' + (this.state.formErrors.email ? 'error' : '')}
                              placeholder='you@here.com'
                              value={this.state.email}
                              onChange={this.handleInputChange} />
                          </p>
                          <em className='desc'>By providing this information, you give a CDPHP sales representative permission to contact you.</em>

                          <p className='submitForm'>
                            <input type='submit' value='Email Me My Quote' className='btn' />
                          </p>
                        </form>
                      </div>
                      {Success}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      );
    }
}

export default SendQuote;



// WEBPACK FOOTER //
// ./src/components/Forms/SendQuote.js